// extracted by mini-css-extract-plugin
export var deliveryRow = "_l7-a";
export var fixedHeight = "_l7-4";
export var freightLogo = "_l7-9";
export var fullWidth = "_l7-3";
export var priceColumn = "_l7-5";
export var radioSelected = "_l7-7";
export var radioUnselected = "_l7-6";
export var selectedOption = "_l7-2";
export var selectedOptionContainer = "_l7-1";
export var selection = "_l7-0";
export var tallSkeletonText = "_l7-8";